import script from "./InterstitialAdModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./InterstitialAdModal.vue?vue&type=script&setup=true&lang=ts"

import "./InterstitialAdModal.vue?vue&type=style&index=0&id=026943f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-026943f8"]])

export default __exports__